import { useMutation } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { getMessage } from '@/helpers/utils';
import i18n from '@/i18n';
import { userService } from '../../services/userService';

const { t } = i18n;

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: payload =>
      userService.forgotPassword(payload).then(response => {
        const { data } = response;
        Notify.success({ text: t('auth:forgot_password.check_your_email') });
        return { success: true, data };
      }),
    onError: error => {
      const status = error?.response?.status;

      if (status >= 400 && status < 500) {
        Notify.error({
          text:
            status === 404
              ? t('auth:forgot_password.email_not_registered')
              : getMessage(error?.response?.data, t('auth:forgot_password.send_email_error')),
        });
      }
    },
  });
};
